import camelCase from 'lodash/camelCase';

export const transformKeysToCamelCase = data =>
  Object.keys(data)
    .map(key => ({ [camelCase(key)]: data[key] }))
    .reduce((prev, next) => {
      return {
        ...prev,
        ...next,
      };
    }, {});
